/* Storefront presentation only: native Shopify query values and catalog data are retained. */
window.ArtVetFacets = {
  enhance(component) {
    const wrapper = component.closest('.collection-wrapper');
    const form = wrapper?.querySelector('#filter');
    if (!form) return;
    wrapper.classList.add('av-facets-ready');
    component.after(form);
    const heading = form.querySelector('header h3');
    if (heading) heading.textContent = component.dataset.filterTitle;
    // The two legacy urinary values are one visible choice. Native filtering ORs them.
    form.addEventListener('change', event => {
      const input = event.target;
      if (input.dataset.avAlias) {
        const alias = document.getElementById(input.dataset.avAlias);
        if (alias) alias.checked = input.checked;
      }
    }, {capture:true, signal:component.abort.signal});
    this.chips(component,wrapper,form);
  },
  chips(component,wrapper,form) {
    const url = new URL(location.href);
    const chips = document.createElement('nav');
    chips.className = 'av-active-filters';
    chips.setAttribute('aria-label',component.dataset.selectedFilters);
    const add = (text,target) => {
      const link = document.createElement('a');
      link.href = target.href;
      link.textContent = text + ' ×';
      link.setAttribute('aria-label',component.dataset.removeFilter.replace('[filter]',text));
      chips.append(link);
    };
    const seen = new Set();
    for (const input of form.querySelectorAll('input[type="checkbox"]:checked:not([data-av-alias-input])')) {
      const label = input.closest('li')?.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!label) continue;
      const copy = label.cloneNode(true);
      for (const count of copy.querySelectorAll('.artvet-facet-count')) count.remove();
      const text = copy.textContent.trim().replace(/\s+/g,' ');
      const key = input.name + ':' + text;
      if (seen.has(key)) continue;
      seen.add(key);
      const target = new URL(url);
      const excluded = [input.value];
      if (input.dataset.avAlias) excluded.push(document.getElementById(input.dataset.avAlias)?.value);
      const keep = target.searchParams.getAll(input.name).filter(value=>!excluded.includes(value));
      target.searchParams.delete(input.name);
      keep.forEach(value=>target.searchParams.append(input.name,value));
      target.searchParams.delete('page'); target.searchParams.delete('av_page');
      add(text,target);
    }
    const min=url.searchParams.get('av_price_min'), max=url.searchParams.get('av_price_max');
    if (min !== null || max !== null) {
      const target=new URL(url);
      for(const key of ['av_price_min','av_price_max','page','av_page']) target.searchParams.delete(key);
      const amount=value=>new Intl.NumberFormat(document.documentElement.lang||'sl',{maximumFractionDigits:2}).format(Number(value));
      const text=component.dataset.priceLabel+': '+(min!==null&&min!==''?amount(min):'0')+' – '+(max!==null&&max!==''?amount(max):'∞')+' '+component.dataset.currency;
      add(text,target);
    }
    wrapper.querySelector('.av-active-filters')?.remove();
    if (!chips.children.length) return;
    const clean = new URL(url);
    for (const key of [...clean.searchParams.keys()]) if (key.startsWith('filter.')||key.startsWith('av_')||key==='page') clean.searchParams.delete(key);
    const clear=document.createElement('a');clear.href=clean.href;clear.className='av-clear-all';clear.textContent=component.dataset.clearAll;chips.append(clear);
    const sorting=wrapper.querySelector('.f8sr');
    if(sorting) sorting.before(chips);
  }
};
